export const toSpaceTabHashMap = (spaceTabs) =>
  spaceTabs.reduce(
    (resultTabs, spaceTab) => ({
      ...resultTabs,
      [spaceTab.spaceTabId]: spaceTab,
    }),
    {},
  );

export const toHashMap = (data) => {
  return (data ?? []).reduce(
    (result, space) => {
      const updatedSpaceOrder = space.private
        ? {
            SharedSpace: result.spaceOrder.SharedSpace,
            PrivateSpace: [...result.spaceOrder.PrivateSpace, space.spaceId],
          }
        : {
            PrivateSpace: result.spaceOrder.PrivateSpace,
            SharedSpace: [...result.spaceOrder.SharedSpace, space.spaceId],
          };

      return {
        spaces: {
          ...result.spaces,
          [space.spaceId]: space,
        },
        spaceTabs: {
          ...result.spaceTabs,
          ...toSpaceTabHashMap(space.spaceTabs ?? []),
        },
        spaceOrder: updatedSpaceOrder,
      };
    },
    {
      spaces: {},
      spaceTabs: {},
      spaceOrder: { PrivateSpace: [], SharedSpace: [] },
    },
  );
};
